import { render, staticRenderFns } from "./ProductPricesDiscounts.vue?vue&type=template&id=00d7886f&scoped=true&"
import script from "./ProductPricesDiscounts.vue?vue&type=script&lang=js&"
export * from "./ProductPricesDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./ProductPricesDiscounts.vue?vue&type=style&index=0&id=00d7886f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d7886f",
  null
  
)

export default component.exports